import ProductMenu from '@elem/compCommon/ProductConstructor/Menu';
import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';
import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import EfEndorsements from 'elem/ui/ef-endorsements';
import EfMediaYoutube from 'elem/ui/ef-media-youtube';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import TheComp from '../AUComps/Media';
import HearStories from './../teaser/HearStories';
import Landing from './../landing';
import ProductBundles from './Bundles';
import ProductGuide from './Guide';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getProductFromGeneralKey, getProductMsg } from '@/utils/productGetServerSideProps';
import { useSupportData } from '@/utils/hooks';
import { useLang } from '@/i18n';
import { useRef } from 'react';

export type SupportRefType = {
    handleChangeForm: () => void;
};

const generalKey = 'product_ps_delta_delta_2_pro';
export default function Crowdfunding({ noHead }: any) {
    const { useState, useRouter, gloproductlist, useEffect } = useGlobal();
    const router = useRouter();
    const { locale, query } = router;
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const IS_NA_SITES = ['us', 'ca'].includes(locale);
    const theme = 'white';
    const { t } = useLang('dp3.crowdfunding.menu');
    const isBuyInCallback = IS_EU_SITES;
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    const supportRef = useRef<SupportRefType>(null);

    // // 如果不存在该页面,返回404
    // if (Object.keys(productMsg).length <= 0 && typeof window !== 'undefined') {
    //     return router.push(`/404`);
    // }

    // {
    //     text: s('tab_product'),
    //     key: 'product',
    // },
    // {
    //     text: s('tab_bundles'),
    //     key: 'bundles',
    // },
    // {
    //     text: s('tab_support'),
    //     key: 'support',
    // },
    // {
    //     text: s('tab_specs'),
    //     key: 'specs',
    // },
    // {
    //     text: s('tab_media'),
    //     key: 'media',
    // },

    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg, productMsg?.spuId || productMsg?.sourceId);

    const data = {
        langKey: 'dp3.crowdfunding',
        menu: {
            title: 'menu.title',
            menus:
                IS_EU_SITES || ['cn'].includes(locale)
                    ? [
                          {
                              text: t('tab_product'),
                              key: 'product',
                          },
                          {
                              text: t('tab_specs'),
                              key: 'specs',
                          },
                          {
                              text: t('tab_support'),
                              key: 'support',
                          },
                      ]
                    : null,
            buyText: IS_EU_SITES || ['de', 'fr'].includes(locale) ? t('buy') : locale === 'br' ? '' : undefined,
        },
        media: {
            title: 'Explore TOP Youtube Reviews of Ecoflow DELTA Pro 3.',
            // banner: {
            //     pc: 'https://websiteoss.ecoflow.com/upload/image/1724122390273/media_banner.jpg',
            //     h5: 'https://websiteoss.ecoflow.com/upload/image/1724122390141/media_banner_768.jpg',
            // },
            items: [
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1724126190182/Hobotech.jpg',
                    title: 'EcoFlow Delta Pro 3 | 4000w 240v Split Phase Solar Generator Power Station',
                    source: 'https://www.youtube.com/embed/qtPNj6XEbiE?si=zIdLDXBulwOqlvFa',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1724126190003/Lead%20Farmer%2073.jpg',
                    title: 'EcoFlow Delta pro 3 The Best Portable Power Station',
                    source: 'https://www.youtube.com/embed/ziCWyqi7nio?si=fmqLB92lXRNf6EMn',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1724133042007/life.jpg',
                    title: 'EcoFlow DELTA Pro 3! Huge Improvements!',
                    source: 'https://www.youtube.com/embed/n6vY9ywELXw?si=epS54_xJzlZqlXiG',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1724126189797/DIY%20Prepper%20TV.jpg',
                    title: 'Power for Your Home AND Off-Grid: Ecoflow Delta Pro 3',
                    source: 'https://www.youtube.com/embed/Op3fdzhn1nc?si=u9-FwKfmXMflbE-3',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1724126190614/Everyday%20Home%20Repairs%20(1).jpg',
                    title: 'Ultimate Power Outage Backup | Power Your Entire House!',
                    source: 'https://www.youtube.com/embed/LzFcdqZaSec?si=ZVax8NLCJ-nHc_Wm',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1724126190463/GreyMan%20Prepping.jpg',
                    title: 'EcoFlow DELTA Pro 3 | Best Power Station In 2024?',
                    source: 'https://www.youtube.com/embed/_zYHtNnuO-A?si=sTEedcfu_cIb8LRI',
                },
            ],
        },
    };

    const { langKey, menu, media } = data;

    const endorsements = {
        title: 'Recognised In The Press',
        lists: [
            {
                logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658862/USA%20Today%20(1).png',
                text: "The most powerful PPSs on the market now rival their gas counterparts.The upcoming launch of the EcoFlow DELTA Pro 3 this surmmer marks significant advancement in home backup power solutions,amplifying EcoFlow's already impressive lineup.",
            },
            {
                logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658871/CNN%202.png',
                text: "The latest DELTA Pro 3, slated for a summer 2024 release, will further enhance these features, establishing it as the brand's flagship solution for energy independence and sustainability.",
            },
            {
                logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658871/Good%20Housekeeping%20(1)%201.png',
                text: 'The combination of portability and quiet operation offers up almost infinite possibilities.',
            },
            {
                logo: 'https://websiteoss.ecoflow.com/upload/image/1724133658947/BobVila%201.png',
                text: "Its wide utility makes it one of the most versatile power stations available, and it's a great asset for any power-hungry DIYfer.",
            },
        ],
    };

    const hasSupportFlag =
        supportData?.downloadList?.length > 0 || supportData?.videoList?.length > 0 || supportData?.faqList?.length > 0 || supportData?.onlineList?.length > 0;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const allow_tabs: string[] = ['cn'].includes(locale)
        ? ['product', 'specs', 'support']
        : ['jp'].includes(locale)
          ? ['product', 'support', 'specs']
          : IS_EU_SITES
            ? ['product', 'support', 'specs']
            : IS_NA_SITES
              ? ['offers', 'product', 'bundles', 'support', 'specs', 'media']
              : ['product', 'support', 'specs'];
    const [tab, setTab] = useState(
        query?.tab && allow_tabs.includes(query?.tab?.toLowerCase()) ? query?.tab?.toLowerCase() : ['us', 'ca']?.includes(locale) ? 'product' : allow_tabs[0],
    );
    const defaultTabObj = {
        product: false,
        bundles: false,
        support: false,
        specs: false,
        media: false,
    };
    const [changedTab, setChangedTab] = useState(
        query?.tab && allow_tabs.includes(query?.tab?.toLowerCase())
            ? { ...defaultTabObj, [query?.tab?.toLowerCase()]: true }
            : { ...defaultTabObj, [allow_tabs[0]]: true },
    );

    const handleScroll = () => {
        if (typeof window !== 'undefined') {
            const barLine = document.querySelector('.dp3-crowdfunding-guide') as HTMLElement; //jp
            //const header = document.querySelector('.ecoflow-frame-header') as HTMLElement;
            window.scrollTo({
                top: (barLine?.clientHeight || 0) + 60,
                behavior: 'smooth', // 可选，平滑滚动
            });
        }
    };

    const handleChangeTab = (tab: string) => {
        if (isBuyInCallback && tab === 'buy') {
            setTab('product');
            setTimeout(() => {
                document.querySelector('#eu-bundles-id')?.scrollIntoView(true);
            }, 100);
            return null;
        }
        setTab(tab);
        if (!changedTab[tab]) {
            setChangedTab({ ...changedTab, [tab]: true });
        }
        if (query?.tab) {
            router.push(
                {
                    pathname: router.pathname,
                    query: { tab: tab },
                },
                undefined,
                { shallow: true, replace: true },
            );
        }
        const bar = document.querySelector('.product-announcement-bar') as HTMLElement;
        if (bar) {
            handleScroll();
        } else {
            const menu = document.querySelector('.product-menu') as HTMLElement;
            if (menu) {
                handleScroll(); // 初始滚动到指定元素位置
            }
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && allow_tabs?.includes(query?.tab?.toLowerCase())) {
            const bar = document.querySelector('.product-announcement-bar') as HTMLElement;
            if (bar) {
                handleScroll(); // 初始滚动到指定元素位置

                window.addEventListener('load', handleScroll);
                // window.addEventListener('resize', handleScroll);

                return () => {
                    window.removeEventListener('load', handleScroll);
                    // window.removeEventListener('resize', handleScroll);
                };
            } else {
                const menu = document.querySelector('.product-menu') as HTMLElement;
                if (menu) {
                    handleScroll(); // 初始滚动到指定元素位置

                    window.addEventListener('load', handleScroll);

                    return () => {
                        window.removeEventListener('load', handleScroll);
                    };
                }
            }
        }
    }, [allow_tabs, query?.tab]);

    useEffect(() => {
        editorEventsBus.on('dp3-tab-change', (tab: string) => {
            handleChangeTab(tab);
        });
    }, []);

    useEffect(() => {
        if (query?.buy === 'bundles') {
            handleChangeTab('bundles');
        }
    }, [query?.buy]);

    const jumpForm = () => {
        handleChangeTab('support');
        setTimeout(() => {
            supportRef.current?.handleChangeForm();
        }, 100);
    };
    return (
        <div className={`dp3-crowdfunding ${css['dp3-crowdfunding']}`}>
            {locale === 'jp' && !noHead && <ProductGuide />}
            <ProductMenu
                hasOffres={false}
                langKey={langKey}
                menu={menu}
                activeTab={tab}
                callTab={handleChangeTab}
                isBuyInCallback={isBuyInCallback}
                hideTabs={
                    ['jp', 'cn']?.includes(locale)
                        ? ['bundles', 'media']
                        : ['br']?.includes(locale)
                          ? ['bundles', 'buy', 'media']
                          : ['mx']?.includes(locale)
                            ? ['bundles', 'media']
                            : IS_EU_SITES
                              ? ['offers', 'bundles', 'media']
                              : ['']
                }
                buyLink={
                    productMsg?.buyLink ||
                    (locale === 'cn'
                        ? 'https://detail.tmall.com/item.htm?id=833100435936&spm=a1z10.1-b-s.w4004-25569180456.28.49a544baLBroZz&skuId=5579838904482'
                        : '')
                } //如果跳转bundle中，则productMsg后台管理中不能配置buyLink
            />
            {(changedTab.product || changedTab.offers) && (
                <div className={`tab-container ${tab === 'product' || tab === 'offers' ? 'active' : ''}`}>
                    <Landing jumpForm={jumpForm} />
                </div>
            )}
            {changedTab.bundles && (
                <div className={`tab-container ${tab === 'bundles' ? 'active' : ''}`}>
                    <ProductBundles />
                </div>
            )}
            {changedTab.support && hasSupportFlag && (
                <div className={`tab-container ${tab === 'support' ? 'active' : ''}`}>
                    <ProductSupport
                        ref={supportRef}
                        hasForm={locale === 'jp'}
                        supportData={supportData}
                        theme={theme}
                        spuId={productMsg?.spuId || productMsg?.sourceId}
                    />
                </div>
            )}
            {changedTab.specs && resProductCatagory && productDetail && (
                <div className={`tab-container ${tab === 'specs' ? 'active' : ''}`}>
                    <ProductSpecs productCatagory={resProductCatagory} productDetail={productDetail} theme={theme} />
                </div>
            )}
            {changedTab.media && (
                <div className={`tab-container ${tab === 'media' ? 'active' : ''}`}>
                    {locale === 'au' ? (
                        <TheComp />
                    ) : IS_NA_SITES ? (
                        <>
                            <div className="dp3-spec"></div>
                            <EfMediaYoutube {...media} />
                            <div className="dp3-spec"></div>
                        </>
                    ) : (
                        <>
                            <HearStories />
                            <div className="dp3-spec"></div>
                            <EfMediaYoutube {...media} />
                            <div className="dp3-spec"></div>
                            <EfEndorsements {...endorsements} />
                            <div className="dp3-spec"></div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
